import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  columnWrapper: {
    animation: '$fadeInSlide 0.3s ease-in-out',
  },
  '@keyframes fadeInSlide': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
});

export default useStyles;
